import { render, staticRenderFns } from "./CompFlipCardList.vue?vue&type=template&id=03ef135a&scoped=true&"
import script from "./CompFlipCardList.vue?vue&type=script&lang=ts&"
export * from "./CompFlipCardList.vue?vue&type=script&lang=ts&"
import style0 from "./CompFlipCardList.vue?vue&type=style&index=0&id=03ef135a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ef135a",
  null
  
)

export default component.exports